import type {PageObject} from '@PosterWhiteboard/page/page.types';
import {isPageVideo} from '@Libraries/page-object.library';
import {getPageDuration, WEBPAGE_STATIC_PAGE_DURATION} from '@Libraries/page-duration.library';

interface WebpagePlaybackPosition {
  pageId: string;
  localTime: number;
}

export const getEffectivePagePlaybackDuration = (page: PageObject): number => {
  const pageDuration = getPageDuration(page);
  if (isPageVideo(page)) {
    return pageDuration;
  }
  return Math.max(pageDuration, WEBPAGE_STATIC_PAGE_DURATION);
};

export const calculateTotalPlaybackDuration = (pages: PageObject[]): number => {
  let totalDuration = 0;
  for (const page of pages) {
    totalDuration += getEffectivePagePlaybackDuration(page);
  }
  return totalDuration;
};

export const calculateGlobalPlaybackTime = (
  pages: PageObject[],
  currentPageId: string,
  currentPageTime: number
): number => {
  let globalTime = 0;
  for (const page of pages) {
    if (page.hashedID === currentPageId) {
      return globalTime + currentPageTime;
    }
    globalTime += getEffectivePagePlaybackDuration(page);
  }
  return globalTime;
};

export const getPlaybackPositionAtGlobalTime = (
  pages: PageObject[],
  globalTime: number
): WebpagePlaybackPosition | undefined => {
  let accumulated = 0;
  for (const page of pages) {
    const pageDuration = getEffectivePagePlaybackDuration(page);
    if (globalTime < accumulated + pageDuration) {
      return {pageId: page.hashedID, localTime: globalTime - accumulated};
    }
    accumulated += pageDuration;
  }

  const lastPage = pages[pages.length - 1];
  if (lastPage) {
    return {pageId: lastPage.hashedID, localTime: getEffectivePagePlaybackDuration(lastPage)};
  }

  return undefined;
};
